<div class='container-fluid corestyle'>
  <div class="row justify-content-center">
    <!-- <div class="each-side col-12 col-lg-3 col-xl-2 mb-3">
      <div *ngIf="item.imgurl" class="d-none d-sm-block">
        <img class="img-fluid mb-1 mx-auto" [src]="item.imgurl" alt="">
      </div>
    </div> -->
    <div class="each-side col-12 col-lg-9 col-xl-8">
      <!-- <div class="d-none d-sm-block mt-3">
          <img class="img-fluid mb-1 mx-auto" [src]="item.imgurl" alt="">
        </div> -->
      <!-- <h1 class="h1"></h1> -->
      <div id="formfill">
        <div class="m-0">
          <p class="fw-bold h4">{{ item.item }}</p>
          <p class="h5" [innerHTML]="item.subtitle"></p>
          <div *ngIf="item.imgurl" class="justify-content-center text-center">
            <img class="img-fluid mb-1 mx-auto w-75" [src]="item.imgurl" alt="">
          </div>
          <div *ngIf="item.date && item.time && item.place && item.address && item.country" class="table-responsive">
            <table class="table">
              <!-- <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col"></th>
                          </tr>
                        </thead> -->
              <tbody>
                <tr>
                  <th scope="row">Date</th>
                  <td>{{ item.date }}</td>
                </tr>
                <tr>
                  <th scope="row">Time</th>
                  <td>{{ item.time }}</td>
                </tr>
                <tr>
                  <th scope="row">Place</th>
                  <td>{{ item.place }}</td>
                </tr>
                <tr>
                  <th scope="row">Address</th>
                  <td>{{ item.address }}</td>
                </tr>
                <tr>
                  <th scope="row">Country</th>
                  <td>{{ item.country }}</td>
                </tr>
              </tbody>

            </table>
          </div>

          <!-- <p>Date: {{ item.date }}</p>
              <p>Time: {{ item.time }}</p>
              <p>Place: {{ item.place }}</p>
              <p>Address: {{ item.address }}</p>
              <p>Country: {{ item.country }}</p> -->
          <!-- <p>Please fill out the form below</p> -->
        </div>

        <ul id="ProductNavTabs" class="nav nav-tabs nav-justified pt-0" role="tablist">
          <li class="nav-item" role="presentation"><a role="tab" type="button" class="nav-link text-truncate active" data-bs-toggle="tab"
              data-bs-target="#DownloadTab_2">{{ 'MISC.RETVIS' | translate }}</a>
          </li>
          <li class="nav-item" role="presentation"><a role="tab" type="button" class="nav-link text-truncate" data-bs-toggle="tab"
              data-bs-target="#DownloadTab_1">{{ 'MISC.NEWVIS' | translate }}</a>
          </li>
        </ul>

        <div id="DownloadTabContent" class="tab-content collapse show">
          <div id="DownloadTab_1" role="tabpanel" class="tab-pane fade"><br>
            <div class="graybackground p-3">
              <form (submit)="downloadPDFButton()" id="{{ item.formtitle }}" name="{{ item.formtitle }}">
                <div class="form-group">
                  <p class="float-end text-end"><span class="text-danger">*</span>
                    {{ 'FORMS.REQUIRE' | translate }}
                  </p>
                  <h2 class="h2 blue">{{ 'CONTACTUS.CONTACTINFO' | translate }}</h2>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.COUNTRY' | translate }}</label>
                    <div class="col">
                      <select type="text" class="form-control col form-select" name="country" [(ngModel)]="countryCode"
                        (change)="getData($event.target)">
                        <option selected>&nbsp;</option>
                        <option *ngFor="let country of countries" value="{{ country.code }}"
                          [attr.data-code]="country.code" [attr.data-region]="country.region"
                          [attr.data-tel]="country.tel_code">{{country.country_name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.FIRST' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="firstname" [(ngModel)]="firstName"
                        placeholder="">
                    </div>

                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.LAST' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="lastname" [(ngModel)]="lastName" placeholder="">
                    </div>
                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.COMPANY' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="company" [(ngModel)]="company" placeholder="">
                    </div>
                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.TITLE' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="jobtitle" [(ngModel)]="title" placeholder="">
                    </div>

                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.COMPADD1' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="address1" [(ngModel)]="address1" placeholder="">
                    </div>

                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label">{{ 'FORMS.COMPADD2' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="address2" [(ngModel)]="address2" placeholder="">
                    </div>
                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label">{{ 'FORMS.COMPADD3' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="address3" [(ngModel)]="address3" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label class="col-3 col-form-label"><span class="text-danger">*
                    </span>{{ 'FORMS.CITY' | translate }}</label>
                  <div class="col">
                    <input type="text" class="form-control col" name="city" [(ngModel)]="city" placeholder="">
                  </div>

                </div>
                <div class="row form-group mb-3">
                  <label class="col-3 col-form-label"><span class="text-danger">*
                    </span>{{ 'FORMS.STATE' | translate }}</label>
                  <div class="col">
                    <input *ngIf="countryObject.code !== 'US'" type="text" class="form-control col" id="state"
                      name="state" [(ngModel)]="state">
                    <select *ngIf="countryObject.code == 'US'" name="stateselect" [(ngModel)]="state"
                      class="form-control form-select">
                      <option disabled selected> </option>
            <option *ngFor="let state of stateOptions" [value]="state.value">{{ state.label }}</option>
                    </select>
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label class="col-3 col-form-label"><span class="text-danger">*
                    </span>{{ 'FORMS.ZIP' | translate }}</label>
                  <div class="col">
                    <input type="text" class="form-control col" name="zip" [(ngModel)]="zipCode" placeholder="">
                  </div>
                </div>
                <!-- <div class="row form-group mb-3">
                      <label class="col-3 col-form-label">{{ 'FORMS.PHONEAREA' | translate }}</label>
                      <div class="col">
                        <input type="text" class="form-control col" name="phoneArea" [(ngModel)]="phoneArea" placeholder="">
                      </div>
                    </div> -->
                <div class="row form-group mb-3">
                  <label class="col-3 col-form-label"><span class="text-danger">*
                    </span>{{ 'FORMS.PHONE' | translate }}</label>
                  <div class="col">
                    <div class="input-group input-group-sm">
                      <span *ngIf="phoneNumberC" class="input-group-text">{{ phoneNumberC }}</span>
                      <input type="text" class="form-control col" name="phone" [(ngModel)]="phoneNumber"
                        placeholder="Without country code" (input)="numberOnly($event)" (keypress)="numberOnly($event)"
                        (paste)="onPaste($event)" minlength="5" maxlength="20">
                    </div>
                  </div>
                </div>
                <div class="row form-group mb-3">
                  <label class="col-3 col-form-label"><span class="text-danger">*
                    </span>{{ 'FORMS.EMAIL' | translate }}</label>
                  <div class="col">
                    <input type="email" class="form-control col" name="email" [(ngModel)]="email" placeholder="">
                  </div>
                </div>
                <div class="py-3">
                  <input type="submit" class="btn btn-primary rounded-pill px-4"
                    value="{{ 'BUTTON.SUBMIT' | translate }}"
                    [disabled]="_httpService.api === false || success == 'Submitting Form'">
                  <button class="btn btn-light rounded-pill ms-3 px-4"
                    type="reset">{{ 'BUTTON.RESET' | translate }}</button>
                </div>
              </form>
            </div>

          </div>
          <div id="DownloadTab_2" role="tabpanel" class="tab-pane fade show active"><br>

            <div class="graybackground p-3">
              <p class="float-end text-end"><span class="text-danger">*</span>
                {{ 'FORMS.REQUIRE' | translate }}
              </p>
              <form (submit)="getReturningCust()" id="{{ item.formtitle }}" name="{{ item.formtitle }}">
                <div class="form-group">
                  <h2 class="h2 blue">{{ 'CONTACTUS.CONTACTINFO' | translate }}</h2>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.EMAIL' | translate }}</label>
                    <div class="col">
                      <input type="email" class="form-control col" name="email" [(ngModel)]="retemail" placeholder="">
                    </div>
                  </div>
                  <div class="row form-group mb-3">
                    <label class="col-3 col-form-label"><span class="text-danger">*
                      </span>{{ 'FORMS.LAST' | translate }}</label>
                    <div class="col">
                      <input type="text" class="form-control col" name="lastname" [(ngModel)]="retlastName"
                        placeholder="">
                    </div>
                  </div>
                  <div class="py-3">
                    <input type="submit" class="btn btn-primary rounded-pill px-4"
                      value="{{ 'BUTTON.SUBMIT' | translate }}"
                      [disabled]="_httpService.api === false || success == 'Submitting Form'">
                  </div>

                  <h5 class="message text-start text-danger my-3">{{reterror}}</h5>
                  <h5 class="message text-start text-success my-3">{{retsuccess}}</h5>
                </div>
              </form>
            </div>
          </div>
        </div>

        <hr>
        <p class="my-3">{{ 'FORMS.SUB1' | translate }} <a class="vx-cursor" data-bs-toggle="modal"
            data-bs-target="#vx-modal-terms">{{ 'FOOTER.TERMSOFUSE' | translate }}</a> {{ 'FORMS.SUB2' | translate }} <a
            class="vx-cursor" data-bs-toggle="modal"
            data-bs-target="#vx-modal-privacy">{{ 'FOOTER.PRIVPOLICY' | translate }}</a>.</p>
        <h5 class="message text-start text-danger my-3">{{error}}</h5>
        <h5 class="message text-start text-success my-3">{{success}}</h5>
      </div>
      <div class='modal problem' id='vx-modal-terms'>
        <div class='modal-dialog modal-lg'>
          <div class='modal-content'>
            <div class='modal-header vx-bg-primary text-white' data-bs-theme="dark">
              <h5 class="modal-title h5">{{ 'FOOTER.TERMSOFUSE' | translate }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                
              </button>
            </div>
            <div class='modal-body'>
              <app-nested-terms-of-use></app-nested-terms-of-use>
            </div>
          </div>
        </div>
      </div>
      <div class='modal problem' id='vx-modal-privacy'>
        <div class='modal-dialog modal-lg'>
          <div class='modal-content'>
            <div class='modal-header vx-bg-primary text-white' data-bs-theme="dark">
              <h5 class="modal-title h5">{{ 'FOOTER.PRIVPOLICY' | translate }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                
              </button>
            </div>
            <div class='modal-body'>
              <app-nested-privacy-policy></app-nested-privacy-policy>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="each-side col-12 col-xl-3 mb-3 w-100">
      <div class="d-md-none">
        <!-- <img class="img-fluid mb-1 mx-auto" [src]="item.imgurl" alt=""> -->
      </div>
    </div>
  </div>
</div>
